import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { reaction } from 'mobx';
import { Card, Tabs, Tooltip } from 'antd';
import VerificationCode from './VerificationCode';
import Password from './Password';
import ForgetPassword from './ForgetPassword';
import CodeVerify from './CodeVerify';
import QrAssistLogin from './QrAssistLogin';
import s from './style.m.less';
import { QuestionCircleOutlined } from '@ant-design/icons';
import InformationModal from '../CustomPage/qhb/InformationModal';
import { Display } from '@/components/Display/Display';
import { logo_isUse_map } from '@/utils/constants';
import ImageRender from '@/components/GrtImage/ImageRender';
import qrcodeLoginIcon from '@/assets/images/login/qrcode_login_icon.webp';
import formLoginIcon from '@/assets/images/login/form_login_icon.webp';
import qrcodeLoginIconRed from '@/assets/images/login/qrcode_login_icon_red.webp';
import formLoginIconRed from '@/assets/images/login/form_login_icon_red.webp';
import { isEnaeaTenant } from './utils';
import theme from '@/theme/themeColor.json';
import { obsDownloadFile } from '@/utils/obsService';
import { ConfigProvider } from 'antd';
@inject('store')
@observer
class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasThemeConfig: false
        };
    }
    componentDidMount() {
        const {
            store: { login }
        } = this.props;
        if (login.tenantInfo?.id) {
            this.setThemeConfig();
            return;
        }
        this.tenantReaction = reaction(
            () => login.tenantInfo,
            (tenantInfo) => {
                if (tenantInfo?.id) {
                    // 先缓存销毁函数
                    const dispose = this.tenantReaction;
                    // 清空引用
                    this.tenantReaction = null;
                    // 执行业务
                    this.setThemeConfig();
                    // 最后销毁
                    dispose();
                }
            }
        );
    }
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };
    onCancel = () => {
        window.location.reload();
    };
    setThemeConfig = async () => {
        const {
            store: { login }
        } = this.props;
        let themeConfig = theme['blue'];
        if (isEnaeaTenant(login.tenantInfo?.id)) {
            themeConfig = theme['red'];
            obsDownloadFile('function-attachment-upload', 'theme/common/themeColor.json').then((res) => {
                if (res) themeConfig = res['red'];
            });
        }
        ConfigProvider.config({
            prefixCls: 'main',
            theme: {
                token: {
                    colorPrimary: themeConfig.primaryColor,
                    ...themeConfig
                }
            }
        });
        //受antd影响 强行覆盖antd自动生成的色值
        for (let key in themeConfig) {
            document.documentElement.style.setProperty('--main-' + key, themeConfig[key]);
        }
        this.setState({ hasThemeConfig: true });
    };

    componentWillUnmount() {
        this.tenantReaction?.();
        const defaultTheme = theme['blue'];
        ConfigProvider.config({
            prefixCls: 'main',
            theme: {
                token: {
                    colorPrimary: defaultTheme.primaryColor,
                    ...defaultTheme
                }
            }
        });
    }
    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <div
                className={s.app}
                style={{
                    backgroundImage: `url(${login.loginCustomConfig?.background_image || ''})`
                }}
            >
                <InformationModal onCancel={this.onCancel} closable={true} title={'完善注册信息'} tip={'请您先完善下方的信息，即可完成注册'}></InformationModal>
                <div className={s['content_box']}>
                    <div
                        className={s['content_left']}
                        style={{
                            backgroundImage: `url(${login.loginCustomConfig?.main_image || ''})`
                        }}
                    >
                        <div className={s['logo_part']}>
                            <Display show={login.loginCustomConfig?.login_checked === logo_isUse_map.SHOW}>
                                <ImageRender className={s['logo']} src={login.loginCustomConfig?.login_image || ''} alt="" />
                            </Display>
                            <div className={s['title']}>{login.loginCustomConfig?.title}</div>
                        </div>
                        <ImageRender className={s['content_splite_img']} src={require('@/assets/images/login/login_custon.webp')} alt="" />
                    </div>
                    <div className={s['content_right']}>
                        <div className={s.content}>
                            {login.mode === 'login' ? (
                                <div>
                                    <div
                                        className={`${s.login_qr_corner} ${s.login_qr_corner_active}`}
                                        onClick={() => login.toggleLoginAssistMode()}
                                    >
                                        { this.state.hasThemeConfig && <img
                                            className={s.login_qr_corner_icon}
                                            src={login.loginAssistMode === 'qr' ?
                                                isEnaeaTenant(login.tenantInfo?.id) ? formLoginIconRed : formLoginIcon :
                                                isEnaeaTenant(login.tenantInfo?.id) ? qrcodeLoginIconRed : qrcodeLoginIcon}
                                        /> }
                                    </div>
                                    { this.state.hasThemeConfig && <Card className={login.loginAssistMode === 'qr' ? s.login_card_qr : s.login_card_form}>
                                        {login.loginAssistMode !== 'qr' ? (
                                            <div className={s.login_head}>
                                                <h3 style={{ margin: '6px 0 12px', fontSize: '20px' }}>欢迎登录</h3>
                                            </div>
                                        ) : null}
                                        {login.loginAssistMode === 'qr' ? (
                                            <QrAssistLogin />
                                        ) : (
                                            <Tabs
                                                onChange={this.onChange}
                                                activeKey={login.activeKey}
                                                items={[
                                                    {
                                                        key: 'code',
                                                        label: '验证码登录',
                                                        children: <VerificationCode />
                                                    },
                                                    {
                                                        key: 'password',
                                                        label: (
                                                            <span>
                                                                密码登录
                                                                <Tooltip title="密码为8-16位，需要至少包含：大写字母、小写字母、数字、特殊符号中的四类，且不能为生日或简单键盘组合">
                                                                    <QuestionCircleOutlined style={{ fontSize: 18, lineHeight: '28px', marginLeft: '4px' }} />
                                                                </Tooltip>
                                                            </span>
                                                        ),
                                                        children: <Password />
                                                    }
                                                ]}
                                            />
                                        )}
                                    </Card> }
                                </div>
                            ) : login.mode === 'codeVerify' ? (
                                //多因子 验证码校验
                                <Card>
                                    <CodeVerify />
                                </Card>
                            ) : (
                                <Card>
                                    <ForgetPassword />
                                </Card>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
